import { Node, mergeAttributes } from '@tiptap/react'

export const FooterParagraph = Node.create({
  name: 'footerParagraph',

  group: 'block',
  content: 'inline*',

  addAttributes() {
    return {}
  },

  parseHTML() {
    return [{ tag: 'p[data-citation-footer]' }]
  },

  renderHTML({ HTMLAttributes }) {
    return [
      'p',
      mergeAttributes(HTMLAttributes, {
        'data-citation-footer': '',
        class: 'citation-footer',
      }),
      0,
    ]
  },
})
